import React, { useEffect, useRef, useState } from "react";

import { getServiceUserList } from "@/services/service-users";
import logger from "@/runtime-utils/observability/logger";
import { AutoCompleteInput, SelectOptions } from "../input";
import { IInput } from "../input/labeledInput";

type Props = {
  value?: SelectOptions | SelectOptions[];
  onSelect: (value: SelectOptions | SelectOptions[]) => void;
  disabled?: boolean;
  errorText?: any;
  inputProps?: IInput;
  multiple?: boolean;
};

const ServiceUserSearch: React.FC<Props> = ({
  multiple = true,
  value,
  onSelect,
  disabled,
  errorText,
  inputProps,
}) => {
  const [options, setOptions] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  // const [open, setOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const loadMoreOptions = async () => {
    try {
      if (loading || !hasMore) return;
      setLoading(true);
      const response = await getServiceUserList({ page, limit: "n/a" });

      if (response.success) {
        setHasMore(response.data.length > 0);

        const data = response.data?.map((el: any) => ({
          label: el.name,
          value: el._id,
        }));

        setOptions((prev) => [...prev, ...data]);
      }
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = (event: Event) => {
    // logger.debug("scroll");
    const target = event.target as HTMLUListElement;
    const bottom =
      target.scrollHeight - target.scrollTop === target.clientHeight;

    logger.debug(`bottom: ${bottom}, loading: ${loading}, hasMore: ${hasMore}`);
    if (bottom && !loading && hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    // logger.debug("add event listener", dropdownRef.current);
    if (dropdownRef.current) {
      const dropdown = dropdownRef.current;
      dropdown.addEventListener("scroll", handleScroll);
      return () => dropdown.removeEventListener("scroll", handleScroll);
    }
  }, []);

  useEffect(() => {
    loadMoreOptions();
  }, [page]);

  return (
    <AutoCompleteInput
      multiple={multiple}
      value={value}
      disabled={disabled}
      loading={loading}
      options={options}
      disableCloseOnSelect
      // slotProps={{
      //   paper: {
      //     ref: dropdownRef,
      //   },
      // }}
      slotProps={{
        listbox: {
          ref: dropdownRef,
        },
      }}
      // ListboxComponent={(props) => <div {...props} ref={dropdownRef} />}
      onSelectItem={(ev: any, newValue: any) => {
        logger.debug(newValue);
        onSelect(newValue);
      }}
      inputProps={{
        ...inputProps,
        placeholder: "User Search",
        errorText,
      }}
      // renderInput={(params) => (
      //   <TextField
      //     {...params}
      //     label="Infinite Loading"
      //     InputProps={{
      //       ...params.InputProps,
      //       endAdornment: (
      //         <>
      //           {loading ? (
      //             <CircularProgress color="inherit" size={20} />
      //           ) : null}
      //           {params.InputProps.endAdornment}
      //         </>
      //       ),
      //     }}
      //   />
      // )}
      // renderOption={(props, option) => (
      //   <Box component="li" {...props}>
      //     {option.title}
      //   </Box>
      // )}
    />
  );
};

export default ServiceUserSearch;
